<template>
  <div class="row justify-content-center align-items-md-center">
    <div class="col-md-8">
      <div class="card full-height bg-ligth">
        <div class="card-header">
          <h3 class="mb-0">
            {{ lista_campos != "" ? "Editar" : "Criar" }} Regra de permissão
          </h3>
        </div>
        <div class="card-body">
          <form @submit.prevent>
            <div class="form-group row">
              <div class="col-md-8">
                <label class="col-md-12">Nome:*</label>
                <input required type="text" class="form-control" v-model="form.name" placeholder="Digite o nome..." />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <input type="text" class="form-control mb-3" v-model="search"
                  placeholder="Pesquisar ação ou grupo..." />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-md-12">Ações:*</label>
                <div class="row">
                  <div class="col-md-6 mb-3" v-for="group in filtered_permissions_mapped_list" :key="group.id">
                    <div class="card">
                      <div class="card-header py-2">
                        <strong>{{ group.label }}</strong>
                      </div>
                      <div class="card-body py-2">
                        <div v-for="perm in group.children" :key="perm.id" class="form-check">
                          <input class="form-check-input" type="checkbox" :id="perm.id" :value="perm.id"
                            v-model="form.permissions" />
                          <label class="form-check-label" :for="perm.id">
                            {{ translatePermission(perm.id) }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12 text-center">
                <button @click.prevent="
                  confirm(lista_campos == '' ? 'cria' : 'edita')
                  " class="btn btn-primary" :disabled="verif">
                  Salvar
                  <b-spinner v-show="verif" small variant="dark" type="grow" label="Spinning"></b-spinner>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fireAlert } from "@/core/mixins/alertMessageMixin";

const PERMISSION_TRANSLATIONS = {
  c_: "Cadastrar",
  u_: "Atualizar",
  d_: "Deletar",
  r_: "Ver",
  ra_: "Ver tudo",
  lock_: "Excluir",
  unlock_: "Restaurar",
  s_: "Salvar ou Enviar ação extra",
  l_by_id_: "busca isolado por ID",
  l_: "busca isolado",
  assign_: "Atribuir",
  revoke_: "Revogar",
  give_: "Conceder",
};

export default {
  mixins: [fireAlert],
  data() {
    return {
      form: {
        name: "",
        permissions: [],
      },
      verif: false,
      search: "",
    };
  },
  created() {
    this.preenxerCampos();
  },
  computed: {
    lista_campos() {
      return this.$store.state.configEmpresa.lista_campos;
    },
    mensagem_alert() {
      return this.$store.state.permissoes.mensagem_alert;
    },
    permissions_mapped_list() {
      let permissions = Object.values(
        this.$store.state.sistema.lista_permissoes_filial
      );

      // Agrupa por sufixo (grupo)
      return permissions
        .reduce((data, current) => {
          let key = current.split("_").pop();
          if (data.indexOf(key) === -1) {
            data.push(key);
          }
          return data;
        }, [])
        .map((group) => {
          return {
            id: group,
            label: group.replace(/([A-Z]+)*([A-Z][a-z])/g, "$1 $2"),
            children: permissions
              .filter((perm) => perm.split("_").pop() === group)
              .map((perm) => ({ id: perm, label: perm })),
          };
        });
    },
    filtered_permissions_mapped_list() {
      if (!this.search) return this.permissions_mapped_list;
      const searchLower = this.search.toLowerCase();
      return this.permissions_mapped_list
        .map((group) => {
          const filteredChildren = group.children.filter(
            (perm) =>
              perm.id.toLowerCase().includes(searchLower) ||
              this.translatePermission(perm.id)
                .toLowerCase()
                .includes(searchLower)
          );
          if (
            group.label.toLowerCase().includes(searchLower) ||
            filteredChildren.length
          ) {
            return {
              ...group,
              children: filteredChildren,
            };
          }
          return null;
        })
        .filter(Boolean);
    },
  },
  methods: {
    translatePermission(perm) {
      // Encontra o prefixo correspondente
      for (const [prefix, label] of Object.entries(PERMISSION_TRANSLATIONS)) {
        if (perm.startsWith(prefix)) return label;
      }
      return perm;
    },
    async confirm(tipo) {
      await this.$confirmacao({
        title: 'Você confirmar a ação?',
        message: `Esta ação  ` + tipo + ` um Perfil no sistema?`,
        type: "is-warning",
        confirmText: "Sim",
        cancelText: "Não",
        onConfirm: () => {
          if (tipo == "cria") this.create();
          if (tipo == "edita") this.update();
        },
        onCancel: () => {
        },
      });
    },
    async create() {
      this.verif = true;
      await this.$store.dispatch("permissoes/create_role", this.form);
      this.verif = false;
      this.fireAlert({
        ...this.mensagem_alert,
        routeName: "permissoes",
      });
    },
    async update() {
      this.verif = true;
      await this.$store.dispatch("permissoes/update_role", this.form);
      this.verif = false;
      this.fireAlert({
        ...this.mensagem_alert,
        routeName: "permissoes",
      });
    },
    async preenxerCampos() {
      if (this.lista_campos != "") {
        this.verif = true;
        await this.$store.dispatch(
          "permissoes/read_role",
          this.lista_campos.id
        );
        let perm = this.$store.state.permissoes.role.permissions.reduce(
          (data, current) => {
            if (data.indexOf(current.name) === -1) {
              data.push(current.name);
            }
            return data;
          },
          []
        );

        perm.forEach((i) => {
          let alias = i.split("_").pop();
          if (
            perm.filter((perm) => perm.split("_").pop() === alias).length >= 8
          ) {
            perm.indexOf(alias) === -1 && perm.push(alias);
          }
        });

        this.form = {
          id: this.lista_campos.id,
          name: this.lista_campos.name,
          permissions: perm,
        };
        this.verif = false;
      }
    },
  },
};
</script>
